let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("cb2FH")]).then(() => parcelRequire('21IPP'));